import React, { useMemo } from "react";
import { FaRedo, FaTimes } from "react-icons/fa";

import { BOOKING_SOURCE_OPTIONS } from "./AddReservation";
import ReservationSearch from "./ReservationSearch";

const ReservationFilters = ({
  filters,
  setFilters,
  hotelOptions = [],
  disableHotelSelect = false,
  userHotelId = "",
  getDefaultDateRange = () => ({ startDate: "", endDate: "" }),
  selectedHotelId = "",
  roomTypeOptions = [],
  roomPlanOptions = [],
  searchQuery = "",
  onSearchChange,
  onClose,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => {
      const next = { ...prev, [name]: value };
      if (name === "hotelId") {
        next.roomTypeId = "";
        next.roomPlanId = "";
      }
      if (name === "roomTypeId") {
        next.roomPlanId = "";
      }
      return next;
    });
  };

  const handleReset = () => {
    const { startDate, endDate } = getDefaultDateRange();
    setFilters({
      searchTerm: "",
      hotelId: disableHotelSelect ? userHotelId : "",
      status: "All",
      source: "",
      startDate,
      endDate,
      roomTypeId: "",
      roomPlanId: "",
    });
    onSearchChange?.("");
  };

  const visibleRoomPlanOptions = useMemo(() => {
    if (!filters.roomTypeId) return roomPlanOptions;
    return roomPlanOptions.filter(
      (plan) => plan.roomId === filters.roomTypeId
    );
  }, [filters.roomTypeId, roomPlanOptions]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0" style={{ fontSize: 16, fontWeight: 600 }}>
          Filters
        </h5>
        <div className="d-flex align-items-center gap-2">
          <button
            type="button"
            className="btn btn-sm btn-secondary d-inline-flex align-items-center gap-1"
            onClick={handleReset}
          >
            <FaRedo />
            Reset
          </button>
          {onClose ? (
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
              onClick={onClose}
              title="Close filters"
            >
              <FaTimes />
              Close
            </button>
          ) : null}
        </div>
      </div>

      <ReservationSearch value={searchQuery} onChange={onSearchChange} />

      <div className="row g-3">
        <div className="col-md-3 col-sm-6">
          <label className="form-label mb-1">Start Date</label>
          <input
            type="date"
            name="startDate"
            className="form-control"
            value={filters.startDate}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-3 col-sm-6">
          <label className="form-label mb-1">End Date</label>
          <input
            type="date"
            name="endDate"
            className="form-control"
            value={filters.endDate}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-3 col-sm-6">
          <label className="form-label mb-1">Hotel</label>
          <select
            className="form-select"
            name="hotelId"
            value={filters.hotelId}
            onChange={handleChange}
            disabled={disableHotelSelect}
            title={
              disableHotelSelect
                ? "Your account is limited to this hotel"
                : undefined
            }
          >
            {!disableHotelSelect && <option value="">All Hotels</option>}
            {hotelOptions.map((h) => (
              <option key={h.value} value={h.value}>
                {h.label}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-3 col-sm-6">
          <label className="form-label mb-1">Status</label>
          <select
            className="form-select"
            name="status"
            value={filters.status}
            onChange={handleChange}
          >
            <option value="All">All</option>
            <option value="Reservation">Reservation</option>
            <option value="Check-in">Check-in</option>
            <option value="Check-out">Check-out</option>
            <option value="Cancelled">Cancelled (hide)</option>
            <option value="No-show">No-show</option>
            <option value="Unconfirmed Reservation">
              Unconfirmed Reservation
            </option>
          </select>
        </div>
        <div className="col-md-3 col-sm-6">
          <label className="form-label mb-1">Source</label>
          <select
            className="form-select"
            name="source"
            value={filters.source}
            onChange={handleChange}
          >
            <option value="">All Sources</option>
            {BOOKING_SOURCE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        {selectedHotelId && (
          <>
            <div className="col-md-3 col-sm-6">
              <label className="form-label mb-1">Room Type</label>
              <select
                className="form-select"
                name="roomTypeId"
                value={filters.roomTypeId}
                onChange={handleChange}
              >
                <option value="">All Room Types</option>
                {roomTypeOptions.map((room) => (
                  <option key={room.value} value={room.value}>
                    {room.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-3 col-sm-6">
              <label className="form-label mb-1">Room Plan</label>
              <select
                className="form-select"
                name="roomPlanId"
                value={filters.roomPlanId}
                onChange={handleChange}
              >
                <option value="">All Room Plans</option>
                {visibleRoomPlanOptions.map((plan) => (
                  <option key={plan.value} value={plan.value}>
                    {plan.label}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ReservationFilters;
